import AppBar from './AppBar';
import Button from './Button';
import Chip from './Chip';
import Divider from './Divider';
import Icon from './Icon';
import IconButton from './IconButton';
import Toolbar from './Toolbar';
import Tooltip from './Tooltip';
import Typography from './Typography';

const atoms = {
  AppBar,
  Button,
  Chip,
  Divider,
  Icon,
  IconButton,
  Toolbar,
  Tooltip,
  Typography
};

export default atoms;

